export default {
  isAdmin: function () {
    return this.$store.state.user.roles.includes('ROLE_ADMIN')
  },
  fields: function () {
    if (this.isAdmin) {
      return [
        {
          key: 'order',
          label: 'Pedido'
        },
        {
          key: 'agency',
          label: 'Agência',
        },
        {
          key: 'created',
          label: 'Data'
        },
        {
          key: 'amount',
          label: 'Valor'
        }
      ]
    }

    return [
      {
        key: 'order',
        label: 'Pedido'
      },
      {
        key: 'created',
        label: 'Data'
      },
      {
        key: 'amount',
        label: 'Valor'
      }
    ]
  }
}
